import React, { useState, useEffect } from 'react';
import { MainLayout } from "@shared/components/md-design-system/Layout/MainLayout";
import { UserDataForm } from '../components/UserDataForm';
import { useNavigation } from '@react-navigation/native';
import { userApi } from '../api/userApi';
import { IPatientData } from '../types/userFormTypes';
import { Loading } from "@shared/components/loading";
import { Telemetry } from 'app/services/telemetry/Telemetry';

const EmergencyContact = () => {
    const navigation = useNavigation();
    const [patientData, setPatientData] = useState<IPatientData | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    // TECHDEBT
    // Issue: https://app.clickup.com/t/86c8fp9eg
    // Description: Direct API call without React Query - missing cache, retry logic, and proper loading states
    const fetchPatientData = async () => {
        try {
            setIsLoading(true);
            const data = await userApi.getPatientData();
            setPatientData(data);
        } catch (error) {
            setPatientData(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPatientData();
    }, []);

    const handleGoBack = () => {
        navigation.goBack();
    };

    const handleSubmitSuccess = () => {
        Telemetry.log('info', 'Emergency contact submitted successfully');
    };

    const handleSubmitError = (error: Error) => {
        Telemetry.error(error);
    };

    const emergencyContact = patientData?.emergency_contacts?.[0];

    const initialValues: Record<string, any> = {
        'emergency_contacts.0.first_name': emergencyContact?.first_name || '',
        'emergency_contacts.0.last_name': emergencyContact?.last_name || '',
        'emergency_contacts.0.relationship': emergencyContact?.relationship || '',
        'emergency_contacts.0.phone_number': emergencyContact?.phone_number || '',
        'emergency_contacts.0.country_code_prefix': emergencyContact?.country_code_prefix || '+39',
    };

    if (isLoading) {
        return (
            <MainLayout navigation={handleGoBack}>
                <Loading />
            </MainLayout>
        );
    }

    return (
        <MainLayout navigation={handleGoBack} scrollable={true}>
            <UserDataForm
                formType="emergency_contact"
                initialValues={initialValues}
                onSubmitSuccess={handleSubmitSuccess}
                onSubmitError={handleSubmitError}
                onDataRefresh={fetchPatientData}
            />
        </MainLayout>
    );
};

export default EmergencyContact;
